/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_Row2Inputs */

const en_mk_proof_panel_row2 = /** @type {(inputs: Mk_Proof_Panel_Row2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pnpm build — no type errors`)
};

const id_mk_proof_panel_row2 = /** @type {(inputs: Mk_Proof_Panel_Row2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pnpm build — tanpa error tipe`)
};

/**
* | output |
* | --- |
* | "pnpm build — no type errors" |
*
* @param {Mk_Proof_Panel_Row2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_row2 = /** @type {((inputs?: Mk_Proof_Panel_Row2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_Row2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_row2(inputs)
	return en_mk_proof_panel_row2(inputs)
});